import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface Action {
  label: string;
  onClick: (employee: any) => void;
}

interface ActionsMenuProps {
  entity: any;
  actions: Action[];
  isAdmin: boolean;
}

export function ActionsMenu({ entity, actions, isAdmin }: ActionsMenuProps) {
  if (!isAdmin) return null;
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {actions.map((action, index) => (
          <DropdownMenuItem key={index} onClick={() => action.onClick(entity)}>
            {t(action.label)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
